import React from 'react';
import { reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { Panel } from 'react-bootstrap';
import CampaignDetails from '../create/CampaignDetails';

const WizardFormStepThree = props => {
  const { handleSubmit, prev, form, selected } = props;

  return (
    <Panel className="create-campaign-step-two">
      <Panel.Body>
        <form onSubmit={handleSubmit}>
          <div className="text-center">
            <h3>Configure your Campaign Settings</h3>
            <div className="text-left">
              <CampaignDetails formName={form} formAction="Wizard" selected={selected} />
            </div>
            <div className="wizard-form-nav">
              <Button onClick={prev}>Back</Button>
              <Button type="submit">Next</Button>
            </div>
          </div>
        </form>
      </Panel.Body>
    </Panel>
  );
};

export default reduxForm({
  form: 'campaignWizardForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(WizardFormStepThree);
